import _slicedToArray from "/home/runner/work/sonos-web-app-tech-blog/sonos-web-app-tech-blog/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { theme } from "@sonos-inc/web-ui-theme";
export var transformCssCustomProperty = function transformCssCustomProperty(prefix, value) {
  return !value || value.startsWith("#") ? value : "var(--" + prefix + "-" + value + ")";
};
export var transformGridValue = function transformGridValue(value, scale) {
  var columns = theme.grid.columns;
  var pattern = /x(\d+)p?(\d*)/;

  var _ref = pattern.exec(value) || [],
      _ref2 = _slicedToArray(_ref, 3),
      cols = _ref2[1],
      _ref2$ = _ref2[2],
      decimal = _ref2$ === void 0 ? 0 : _ref2$;

  if (cols) {
    return 100 * parseFloat(cols + "." + decimal) / columns + "vw";
  }

  return scale && value in scale ? scale[value] : value;
};